import VendorRootLayout from "./VendorRootLayout";

export default VendorRootLayout;
